goog.provide("shadow.js.shim.module$$mui$material$DialogActions");
goog.provide("module$shadow_js_shim_module$$mui$material$DialogActions");
shadow.js.shim.module$$mui$material$DialogActions = shadow.js.nativeProvides["@mui/material/DialogActions"] = shadow$bridge("@mui/material/DialogActions");
module$shadow_js_shim_module$$mui$material$DialogActions.default = shadow.js.shim.module$$mui$material$DialogActions;
